'use client';

import { ThemeProvider } from '@mui/material';
import { AppRouterCacheProvider } from '@mui/material-nextjs/v15-appRouter';
import { GlobalStyles, THEME } from '@/theme';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useAxiosInterceptors, useAnalyticsTimerThreeMin } from '@/hooks';
import { NuqsAdapter } from 'nuqs/adapters/next/app';

type ProvidersProps = {
  children: React.ReactNode;
};

export const Providers = ({ children }: ProvidersProps) => {
  const pathname = usePathname();
  useAxiosInterceptors();
  useAnalyticsTimerThreeMin();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            retry: false,
          },
        },
      }),
  );

  return (
    <NuqsAdapter>
      <QueryClientProvider client={queryClient}>
        <AppRouterCacheProvider>
          <ThemeProvider theme={THEME}>
            <GlobalStyles />
            {children}
          </ThemeProvider>
        </AppRouterCacheProvider>
      </QueryClientProvider>
    </NuqsAdapter>
  );
};
